import React from "react";
import Modal from "../../lib/ModalWindow/Modal";
import LoginForm from "./LoginForm/LoginForm";
import { useTranslation } from "react-i18next";


const NotloggedinModal: React.FC<{isVisible: boolean; closeFunction: () => void; onLoggedIn?: () => void}> = ({
  isVisible,
  closeFunction,
  onLoggedIn,
}) => {
  const t = useTranslation().t
  return (
    <Modal isVisible={isVisible} closeFunction={closeFunction} modalTitle={t("form.pleaseLogIn")}>
      <LoginForm onLoggedIn={onLoggedIn} />
    </Modal>
  );
};

export default NotloggedinModal;
